import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "m-20"
};
const _hoisted_2 = {
  class: "wrap text-black"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock("main", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
    class: "bg_white searchBox"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form, {
        ref: "form",
        model: $data.filter,
        "label-width": "100px",
        class: "m-t-20"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "名称",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.filter.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.filter.name = $event),
                style: {
                  "width": "220px"
                },
                placeholder: "请输入专利名称/公司名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "专利类型",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: $data.filter.patent_type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.filter.patent_type = $event),
                placeholder: "请选择专利类型"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.patentType, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "公告时间",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: $data.filter.publish_time,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.filter.publish_time = $event),
                type: "date",
                placeholder: "请选择公告时间",
                "value-format": "YYYY-MM-DD",
                onChange: $options.changePublishTime
              }, null, 8, ["modelValue", "onChange"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "续费时间",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: $data.filter.renewals_time,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.filter.renewals_time = $event),
                type: "date",
                placeholder: "请选择续费时间",
                "value-format": "YYYY-MM-DD",
                onChange: $options.changeRenewalsTime
              }, null, 8, ["modelValue", "onChange"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "项目负责人",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_cascader, {
                modelValue: $data.depts,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.depts = $event),
                options: $data.deptData,
                props: {
                  expandTrigger: 'hover',
                  value: 'dept_code',
                  label: 'dept_name',
                  children: 'children'
                },
                onChange: $options.changeDept
              }, null, 8, ["modelValue", "options", "onChange"]), _createVNode(_component_el_select, {
                modelValue: $data.admin_ids,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.admin_ids = $event),
                placeholder: "请选择项目负责人",
                onChange: $options.selLeader
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.adminData, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.staff_name,
                    value: item.staff_code
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue", "onChange"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            offset: 1
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "申请人",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_cascader, {
                modelValue: $data.admins,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.admins = $event),
                options: $data.deptData,
                props: {
                  expandTrigger: 'hover',
                  value: 'dept_code',
                  label: 'dept_name',
                  children: 'children'
                },
                onChange: $options.changeDept1
              }, null, 8, ["modelValue", "options", "onChange"]), _createVNode(_component_el_select, {
                modelValue: $data.apply_man,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.apply_man = $event),
                placeholder: "请选择申请人",
                onChange: $options.changeAdmin
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.adminData1, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.staff_name,
                    value: item.staff_code
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue", "onChange"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4,
            offset: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: $options.searchClick
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("搜索")])),
              _: 1,
              __: [10]
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              type: "primary",
              onClick: $options.reset
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("重置")])),
              _: 1,
              __: [11]
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bg_white m-t-20"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "m-t-20"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6,
          class: "m-l-40"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: $options.addClick
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("新增专利")])),
            _: 1,
            __: [12]
          }, 8, ["onClick"]), _createVNode(_component_el_button, {
            class: "m-l-10",
            type: "primary",
            onClick: _cache[8] || (_cache[8] = $event => $options.downloadTemplate(''))
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("下载专利交底模板")])),
            _: 1,
            __: [13]
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_table, {
        class: "m-20",
        data: $data.tableData,
        style: {
          "width": "auto"
        },
        border: "",
        "header-cell-style": $data.header_style
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          fixed: "",
          prop: "id",
          label: "编码",
          width: "80",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "name",
          label: "专利名称（型号）",
          width: "180"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            onClick: $event => $options.editClick(scope.row),
            class: "text_blue Cursor"
          }, _toDisplayString(scope.row.name), 9, _hoisted_3)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "patent_type_id",
          label: "专利类型",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "admin_ids",
          label: "项目负责人",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "progress",
          label: "申请进度"
        }), _createVNode(_component_el_table_column, {
          prop: "is_outcountry",
          label: "是否涉及国外",
          width: "120",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "worth_level",
          label: "价值级别",
          width: "100",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "org_ids",
          label: "申请主体"
        }), _createVNode(_component_el_table_column, {
          prop: "apply_country",
          label: "申请国家",
          width: "100",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "",
          label: "技术交底",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            class: "text_blue Cursor",
            onClick: $event => $options.downloadTemplate(scope.row.technical_disclosure)
          }, "下载", 8, _hoisted_4)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "",
          label: "产品图片",
          width: "180",
          align: "center"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_image, {
            src: scope.row.production_image,
            style: {
              "width": "50px",
              "height": "50px"
            }
          }, null, 8, ["src"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "production_desc",
          label: "产品功能简介",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "checkout_result",
          label: "检索结果",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "apply_result",
          label: "申请结果",
          width: "300"
        }), _createVNode(_component_el_table_column, {
          prop: "apply_time",
          label: "申请时间",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "publish_time",
          label: "公告时间",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "renewals_time",
          label: "续费时间",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "price",
          label: "单价（￥）",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "num",
          label: "数量",
          width: "180",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "total_price",
          label: "总计（￥）",
          width: "180",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "",
          label: "操作",
          width: "180",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            onClick: $event => $options.editClick(scope.row),
            class: "text_blue Cursor m-r-10"
          }, "查看详情", 8, _hoisted_5), _createElementVNode("span", {
            onClick: $event => $options.deleteClick(scope.row, scope.$index),
            class: "text_blue Cursor"
          }, "删除", 8, _hoisted_6)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "header-cell-style"]), _createVNode(_component_el_row, {
        class: "p-20"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_pagination, {
          class: "pagination",
          modelValue: $data.currentPage,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.currentPage = $event),
          "page-size": $data.filter.size,
          layout: "total, prev, pager, next",
          total: $data.total,
          onSizeChange: $options.changePageSize,
          onCurrentChange: $options.changePage
        }, null, 8, ["modelValue", "page-size", "total", "onSizeChange", "onCurrentChange"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })])]);
}